<template>
  <v-card-text>
    <h3 class="body-1 primary--text ma-0">{{ dates }}</h3>
    <h4 class="subheading ma-0">{{ diploma.level + ' - ' + diploma.domain }}</h4>
    <p class="caption grey--text ma-0">{{ diploma.schoolName }}</p>
    <p class="caption grey--text ma-0" style="white-space: pre-line">{{ diploma.details }}</p>
  </v-card-text>
</template>

<script>
import dayjs from 'dayjs'
import i18n from '@/helpers/i18n'

export default {
  props: {
    diploma: {
      type: Object,
      required: true
    }
  },
  computed: {
    dates: function() {
      return this.$t('candidate-profile-education-dates', 'fr', {
        from: this.formatDate(this.diploma.startDate),
        to: this.formatDate(this.diploma.graduationDate)
      })
    }
  },
  methods: {
    formatDate: function(dateString) {
      return i18n.getLocalizedMonthYear(dayjs(dateString))
    }
  }
}
</script>
